import { IArticlesData, IArticlesAction } from 'models/magazine/article/articles';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import { ArticleStatus } from 'models/enums/statuses';
import { nullCheck } from 'helpers/common';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'articles/REQUEST_START';
export const REQUEST_FAILURE: string = 'articles/REQUEST_FAILURE';
export const GET_ARTICLES_SUCCESS: string = 'articles/GET_ARTICLES_SUCCESS';
export const SET_ITEMS_PAGE: string = 'articles/SET_ITEMS_PAGE';
export const SET_USER_ID: string = 'articles/SET_USER_ID';
export const RESET_DATA: string = 'articles/RESET_DATA';
export const SET_LAST_SEARCHED_KEYWORD: string = 'articles/SET_LAST_SEARCHED_KEYWORD';
export const SET_STATUS_FILTER: string = 'articles/SET_STATUS_FILTER';
export const SET_LANGUAGE_FILTER: string = 'articles/SET_LANGUAGE_FILTER';
export const SET_SEARCH_FILTER: string = 'articles/SET_SEARCH_FILTER';
export const SET_SORT_FILTER: string = 'articles/SET_SORT_FILTER';
export const SET_ISFIRSTLOAD: string = 'articles/SET_ISFIRSTLOAD';
export const RESET_FILTERS: string = 'articles/RESET_FILTERS';

/** Initial State */
const initialState: IArticlesData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 100,
		items: [],
	},
	keywordFilter: '',
	sortFilter: null,
	statusFilter: 'allposts',
	languageKeyFilter: '',
	userId: null,
	lastSearchedKeyword: null,
	isFirstLoad: false,
};

/** Reducer */
export function articlesReducer(state = initialState, action: IArticlesAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_ARTICLES_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 100,
					items: [],
				},
				userId: null,
			});

		case RESET_FILTERS:
			return Object.assign({}, state, {
				keywordFilter: '',
				sortFilter: null,
				statusFilter: 'allposts',
				languageKeyFilter: '',
			});

		case SET_STATUS_FILTER:
			return Object.assign({}, state, {
				keywordFilter: '',
				sortFilter: 0,
				languageKeyFilter: '',
				statusFilter: action.payload.statusFilter,
				isFirstLoad: true,
			});

		case SET_LANGUAGE_FILTER:
			return Object.assign({}, state, {
				languageKeyFilter: action.payload.languageKeyFilter,
				isFirstLoad: true,
			});

		case SET_SORT_FILTER:
			return Object.assign({}, state, {
				sortFilter: action.payload.sortFilter,
				isFirstLoad: true,
			});

		case SET_SEARCH_FILTER:
			return Object.assign({}, state, {
				keywordFilter: action.payload.keywordFilter,
				isFirstLoad: true,
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		case SET_USER_ID:
			return Object.assign({}, state, {
				userId: action.payload.userId,
			});

		case SET_LAST_SEARCHED_KEYWORD:
			return Object.assign({}, state, {
				lastSearchedKeyword: action.payload.lastSearchedKeyword,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getArticles(id: string, isFirstLoad: boolean) {
	return (dispatch, getState: () => IStore) => {
		//const userPreferences: IUserPreferences = getState().userPreferences;

		if (isFirstLoad) {
			dispatch(resetArticlesData());
			dispatch(setArticlesIsFirstLoad(false));
		}

		if (id !== null) {
			dispatch(setUserId(id));
		}

		dispatch(requestStart());

		const currentPage: number = getState().articles.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().articles.itemsPage.itemsPerPage;

		let queryString = '?';
		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;
		queryString = queryString + '&sortColumn=' + mapUserArticlesSort(getState().articles.sortFilter);

		const userId: string = id === null ? getState().articles.userId : id;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/GetByUser/' + userId + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						if (isFirstLoad) {
							dispatch(resetArticlesData());
						}
						const articlesState: IArticlesData = getState().articles;
						const items: IArticleListCard[] = articlesState.items;
						const newItems: IArticleListCard[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getArticlesSuccess(items));
						dispatch(setItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getAdminArticles() {
	return (dispatch, getState: () => IStore) => {
		if (getState().articles.isFirstLoad) {
			dispatch(resetArticlesData());
			dispatch(setArticlesIsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().articles.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().articles.itemsPage.itemsPerPage;

		let queryString = '?';
		if (getState().articles.keywordFilter && getState().articles.keywordFilter !== '') {
			queryString = queryString + '&keyword=' + getState().articles.keywordFilter;
		}

		if (getState().articles.languageKeyFilter) {
			queryString = queryString + '&languageKey=' + getState().articles.languageKeyFilter;
		}

		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;
		queryString = queryString + '&sortBy=' + mapAdminArticlesSort(getState().articles.sortFilter);
		if (getState().articles.statusFilter === 'unlisted') {
			queryString = queryString + '&listed=false';
		} else if (nullCheck(mapAdminArticlesStatus(getState().articles.statusFilter))) {
			queryString = queryString + '&articleStatus=' + mapAdminArticlesStatus(getState().articles.statusFilter);
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/All' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						const articlesState: IArticlesData = getState().articles;
						const items: IArticleListCard[] = articlesState.items;
						const newItems: IArticleListCard[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getArticlesSuccess(items));
						dispatch(setItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function deleteArticle(itemId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/' + itemId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(deleteArticleFromList(itemId));
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Article_Deleted'), kind: 'success', dismissAfter: 3000 }),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function deleteArticleFromList(itemId: string) {
	return (dispatch, getState: () => IStore) => {
		const items: IArticleListCard[] = getState().articles.items;
		const index = items.indexOf(items.find((x: IArticleListCard) => JSON.parse(x.entityId).id === itemId));
		items.splice(index, 1);
		dispatch(getArticlesSuccess(items));
	};
}

function mapAdminArticlesStatus(status: string): string {
	let mappedStatus = null;
	switch (status) {
		case 'allposts':
			mappedStatus = null;
			break;
		case 'approved':
			mappedStatus = ArticleStatus.Approved;
			break;
		case 'pending':
			mappedStatus = ArticleStatus.InApproval;
			break;
		case 'drafts':
			mappedStatus = ArticleStatus.Draft;
			break;

		default:
			mappedStatus = null;
	}
	return mappedStatus;
}

function mapAdminArticlesSort(sort: number): string {
	let mappedSort = 'NewestOldest';
	switch (sort) {
		case 0:
			mappedSort = 'NewestOldest';
			break;
		case 1:
			mappedSort = 'OldestNewest';
			break;
		default:
			mappedSort = 'NewestOldest';
	}
	return mappedSort;
}

function mapUserArticlesSort(sort: number): string {
	let mappedSort = 'AddedDate DESC';
	switch (sort) {
		case 0:
			mappedSort = 'AddedDate DESC';
			break;
		case 1:
			mappedSort = 'AddedDate ASC';
			break;
		case 2:
			mappedSort = 'LikesCount DESC';
			break;
		default:
			mappedSort = 'AddedDate DESC';
	}
	return mappedSort;
}

/** Action Creator */
export function requestStart(): IArticlesAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getArticlesSuccess(items: IArticleListCard[]): IArticlesAction {
	return {
		type: GET_ARTICLES_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IArticlesAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IArticlesAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetArticlesData(): IArticlesAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setUserId(userId: string): IArticlesAction {
	return {
		type: SET_USER_ID,
		payload: {
			userId,
		},
	};
}

/** Action Creator */
export function setArticlesLastSearchedKeyword(lastSearchedKeyword: string): IArticlesAction {
	return {
		type: SET_LAST_SEARCHED_KEYWORD,
		payload: {
			lastSearchedKeyword,
		},
	};
}

export function setArticlesStatusFilter(statusFilter: string): IArticlesAction {
	return {
		type: SET_STATUS_FILTER,
		payload: {
			statusFilter,
		},
	};
}

export function setArticlesLanguageFilter(languageKeyFilter: string): IArticlesAction {
	return {
		type: SET_LANGUAGE_FILTER,
		payload: {
			languageKeyFilter,
		},
	};
}

export function setArticlesSearchFilter(keywordFilter: string): IArticlesAction {
	return {
		type: SET_SEARCH_FILTER,
		payload: {
			keywordFilter,
		},
	};
}

export function setArticlesSortFilter(sortFilter: number): IArticlesAction {
	return {
		type: SET_SORT_FILTER,
		payload: {
			sortFilter,
		},
	};
}

export function resetArticlesFilters(): IArticlesAction {
	return {
		type: RESET_FILTERS,
	};
}

export function setArticlesIsFirstLoad(isFirstLoad: boolean): IArticlesAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}
